const separator = '[ -]?';

const optionalPrefix = '((\\+48)|(0048))?';
const numbersGroup = '[0-9]{3}';
export const mobilePhoneRegexPattern = `^${optionalPrefix}${separator}${numbersGroup}${separator}${numbersGroup}${separator}${numbersGroup}$`;

const direction = '[0-9]{2}?';
const firstNumbersGroup = '[0-9]{3}';
const secondNumbersGroup = '[0-9]{2}';
const thirdNumbersGroup = '[0-9]{2}';
export const homePhoneRegexPattern = `^${direction}${separator}${firstNumbersGroup}${separator}${secondNumbersGroup}${separator}${thirdNumbersGroup}$`;

export const mobileOrHomePhoneRegexPattern = `(${mobilePhoneRegexPattern})|(${homePhoneRegexPattern})`;

export const nameRegexPattern = '^[\\p{L}-]+ [\\p{L} -]+$';
